import { makeAutoObservable } from 'mobx';
import guid from '../../../../utils/guid';

export default class Thumb {
  id;
  date_created;
  s3;

  constructor({ id = guid(), date_created = new Date(), s3 = '' }) {
    this.id = id;
    this.date_created = date_created;
    this.s3 = s3;

    makeAutoObservable(this);
  }
}
